module.exports = __webpack_public_path__ + "media/assets/images/category/StarringYou@2x-1098948082621a5c32bf2c324ab70a97.png";